export interface FlatTreeNodeInterface {
  id?: number;
  depth: number;
  lft: number;
  rgt: number;
}

export class FlatTreeNodeFixture implements FlatTreeNodeInterface {
  id = 1;
  depth = 0;
  lft = 1;
  rgt = 2;
  constructor(props: Partial<FlatTreeNodeInterface>) {
    Object.assign(this, props);
  }
}

export function getAllAncestorsForNode<T extends FlatTreeNodeInterface>(
  nodeId: number,
  branchesToSearch: T[],
  options: { includeSelf: boolean }
): T[] {
  if (!nodeId) return [];
  const node = branchesToSearch.find((branch) => branch.id === nodeId);
  if (!node) return [];
  return branchesToSearch.filter((branch) => {
    if (options.includeSelf && branch.id === node.id) {
      return true;
    }
    return branch.depth < node.depth && branch.lft < node.lft && branch.rgt > node.rgt;
  });
}
